(() => {
  const configElement = document.getElementById('AlmatarGuestWishlistConfig');
  if (!configElement) return;
  const text = JSON.parse(configElement.textContent);
  const key = 'almatar:guest-wishlist:v1';
  const selector = '[data-almatar-wishlist-button]';
  const read = () => {
    const value = JSON.parse(localStorage.getItem(key) || '{}');
    return value && typeof value === 'object' && !Array.isArray(value) ? value : {};
  };
  const variant = button => String(button.closest('.almatar-product-chapter')?.querySelector('[data-selected-variant]')?.value || button.dataset.variantId || '');
  const state = button => {
    let selected = false;
    try {
      const item = read()[button.dataset.productId];
      selected = Boolean(item && String(item.variantId || '') === variant(button));
    } catch {}
    button.dataset.wishlisted = String(selected);
    button.classList.toggle('is-wishlisted', selected);
    button.setAttribute('aria-pressed', String(selected));
    button.title = text.note;
    const label = button.querySelector('[data-almatar-wishlist-label]');
    const heart = button.querySelector('[data-almatar-wishlist-heart]');
    if (label) label.textContent = selected ? text.saved : text.add;
    if (heart) heart.textContent = selected ? '\u2665' : '\u2661';
  };
  function initialize(root = document) {
    const candidates = root.matches?.(selector) ? [root] : [...(root.querySelectorAll?.(selector) || [])];
    for (const original of candidates) {
      if (original.dataset.almatarGuestWishlistReady === 'true') continue;
      const button = original.cloneNode(true);
      button.dataset.almatarWishlistBound = 'true';
      button.dataset.almatarGuestWishlistReady = 'true';
      button.disabled = false;
      button.removeAttribute('aria-busy');
      original.replaceWith(button);
      button.addEventListener('click', event => {
        event.preventDefault();
        try {
          const id = String(button.dataset.productId || '');
          if (!/^\d+$/.test(id)) return;
          const items = read();
          const currentVariant = variant(button);
          const selected = Boolean(items[id] && String(items[id].variantId || '') === currentVariant);
          if (selected) delete items[id];
          else items[id] = { productId: id, variantId: currentVariant, savedAt: new Date().toISOString() };
          localStorage.setItem(key, JSON.stringify(items));
          document.querySelectorAll(selector).forEach(state);
          document.dispatchEvent(new CustomEvent('almatar:wishlist:changed', { detail: { productId: id, variantId: currentVariant || null, wishlisted: !selected, guest: true } }));
        } catch {
          if (window.AlmatarUI?.error) window.AlmatarUI.error(text.error);
          else window.alert(text.error);
        }
      });
      button.addEventListener('almatar:wishlist:variant-change', () => state(button));
      state(button);
    }
  }
  initialize();
  new MutationObserver(mutations => {
    for (const mutation of mutations) for (const node of mutation.addedNodes) if (node instanceof Element) initialize(node);
  }).observe(document.documentElement, { childList: true, subtree: true });
  window.addEventListener('storage', event => {
    if (event.key === key) document.querySelectorAll(selector).forEach(state);
  });
  document.addEventListener('shopify:section:load', event => initialize(event.target));
})();
